<script>
  import { router } from '@inertiajs/svelte'
  
  let { notice = null, recovery_codes = [] } = $props();
  
  function generateNewCodes() {
    router.post('/two_factor_authentication/profile/recovery_codes');
  }
</script>

<div class="recovery-codes-container">
  {#if notice}
    <p class="notice">{notice}</p>
  {/if}

  <h1>Two-factor recovery codes</h1>
  <p>Recovery codes provide a way to log in if you lose your phone (or don't have it with you). Save these and keep them somewhere safe.</p>

  <ul class="codes-list">
    {#each recovery_codes as code}
      {#if code.used}
        <li class="code used"><del>{code.code}</del></li>
      {:else}
        <li class="code">{code.code}</li>
      {/if}
    {/each}
  </ul>

  <div class="action-link">
    <a href="/">OK, I'm done</a>
  </div>

  <hr>

  <h2>Need new recovery codes?</h2>

  <p>If you think your codes have fallen into the wrong hands, you can get a new set. Be sure to save the new ones because the old codes will stop working.</p>

  <button class="generate-button" onclick={generateNewCodes}>Generate new recovery codes</button>
</div>

<style>
  .recovery-codes-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  
  .notice {
    color: green;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #ecfdf5;
    border-radius: 0.375rem;
  }
  
  .codes-list {
    margin: 2rem 0;
    padding-left: 1.5rem;
    font-family: monospace;
    font-size: 1.25rem;
    letter-spacing: 0.1em;
    line-height: 2;
    background-color: #f3f4f6;
    padding: 1.5rem;
    border-radius: 0.375rem;
  }
  
  .code.used {
    color: #9ca3af;
  }
  
  .action-link {
    margin: 1.5rem 0;
  }
  
  .action-link a {
    color: #047857;
    text-decoration: none;
    font-weight: 500;
  }
  
  .action-link a:hover {
    text-decoration: underline;
  }
  
  .generate-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
    margin-top: 1rem;
  }
  
  .generate-button:hover {
    background-color: #065f46;
  }
  
  hr {
    margin: 2rem 0;
    border: 0;
    border-top: 1px solid #e5e7eb;
  }
</style>